const CartStore = require("stores/abstract/CartStore");
const env = require("services/env");

module.exports = new CartStore(env.get("stores.cart"));


// WEBPACK FOOTER //
// ./resources/js/stores/CartStore.js